/**
 * 檢測是否為行動裝置
 * @returns {boolean} 是否為行動裝置
 */
export function isMobileDevice(): boolean {
    // 檢測觸控設備
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    // 檢測行動裝置的 User Agent
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const isMobileUA = mobileRegex.test(navigator.userAgent);
    
    // 檢測螢幕尺寸
    const isSmallScreen = window.innerWidth <= 768 || window.innerHeight <= 768;
    
    // 檢測設備像素比和螢幕方向
    const isMobileScreen = window.matchMedia('(max-width: 768px)').matches;
    
    return hasTouch && (isMobileUA || isSmallScreen || isMobileScreen);
}

/**
 * 格式化檔案大小
 * @param bytes 位元組數
 * @returns 格式化後的檔案大小字串
 */
export function formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}
